
import Nl2br from '~/mixins/nl2br.js'
import ChevronIcon from '~/assets/icons/chevron.svg'

export default {
  name: 'ProductDescriptionAccordionItem',
  components: {
    ChevronIcon,
  },
  mixins: [Nl2br],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    id: {
      type: Number,
      required: true,
      default: null
    },
    groupId: {
      type: Number,
      required: true,
      default: null
    },
    textColor: {
      type: String,
      required: false,
      default: '#383838'
    },
    itemPadding: {
      type: String,
      required: false,
      default: '--small'
    },
    titleSize: {
      type: String,
      required: false,
      default: 'h-large'
    },
    titleType: {
      type: String,
      required: false,
      default: 'h3'
    },
  },
  data () {
    return {
      isActive: false,
    }
  },
  computed: {
    sanatiseText () {
      return this.item.content.html.replace('/site', '')
    },
    itemId () {
      return `item-${this.groupId}-${this.id}`
    }
  },
  methods: {
    toggle () {
      this.isActive = !this.isActive
    },
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },

    endTransition (el) {
      el.style.height = ''
    }
  },

}
